import Footer from "robofox-copyright-footer";

const WillfulFooter = () => {
  return <Footer companyName="WG LLC" developerName="RoboFox" />;
};

export default WillfulFooter;
